import React from 'react';
import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';

const AdminTopBar = ({ onLogout }) => (
  <header className="bg-[#1e293b] text-white sticky top-0 z-30 shadow">
    <div className="px-4 h-14 flex items-center justify-between">
      <Link to="/admin" className="flex items-center gap-2">
        <div className="w-8 h-8 rounded bg-[#ee5e23] flex items-center justify-center font-bold">T</div>
        <span className="font-semibold">TelanganaMart Admin</span>
      </Link>
      <div className="flex items-center gap-3">
        <a href="/" target="_blank" rel="noreferrer" className="text-xs text-gray-300 hover:text-white">View Site ↗</a>
        <button onClick={onLogout} className="flex items-center gap-1 text-xs px-3 py-1.5 rounded bg-white/10 hover:bg-white/20 transition-colors" data-testid="admin-logout-btn">
          <LogOut className="w-3.5 h-3.5" /> Sign out
        </button>
      </div>
    </div>
  </header>
);

export default AdminTopBar;
